<div class="m-content h-100 d-flex">
    <div style="width: 200px; margin-left: -15px" class="mr-4">
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <span class="m-portlet__head-text">PODIZVAJALCI</span>
                    </div>
                </div>
            </div>
            <div class="h-100">
                <cal-subs-list
                    *ngIf="allSubcontractors$ | async"
                    [allSubcontractors]="allSubcontractors$ | async"
                    [selectedSubconstractors]="selectedSubconstractors$ | async"
                    (onChangeSelect)="reloadEventsPublic($event)"
                    (changeSubcontractorFilter)="reloadEventsPublic($event)"
                ></cal-subs-list>
            </div>
        </div>
    </div>
    <div class="row h-100 w-100">
        <div *ngIf="isMdpsModuleActive" class="col-xl col-md-12 flex-grow-0">
            <div class="m-portlet h-100">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <span class="m-portlet__head-text">NEZAKLJUČENI</span>
                        </div>
                    </div>
                </div>
                <div [id]="'col5'" class="m-portlet__body h-100">
                    <div *ngFor="let reservation of (pendingReservations$ | async).value" class="element-container m-1">
                        <inx-kab-item
                            [data]="{
                                data: reservation,
                                status: 'col1',
                                isPriority: isPriority(reservation.reservationFrom)
                            }"
                            [showDate]="true"
                            [draggable]="false"
                        ></inx-kab-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl col-md-12 flex-grow-0">
            <div class="m-portlet h-100">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <span class="m-portlet__head-text">NAROČENI DANES</span>
                        </div>
                    </div>
                </div>
                <div
                    [id]="'col1'"
                    [cdkDropListData]="columns?.col1"
                    [cdkDropListConnectedTo]="['col2', 'col3', 'col4']"
                    (cdkDropListDropped)="drop($event)"
                    cdkDropList
                    cdkDropListSortingDisabled
                    class="m-portlet__body h-100"
                    [ngClass]="{ 'mf-highlight-column': highlightColumns.col1 }"
                >
                    <div
                        *ngFor="let comp of columns?.col1"
                        [cdkDragData]="comp"
                        (cdkDragStarted)="onDrag($event?.source)"
                        (cdkDragEnded)="endDrag($event)"
                        cdkDrag
                        class="element-container"
                    >
                        <inx-kab-item [data]="comp"></inx-kab-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl col-md-12 flex-grow-0">
            <div class="m-portlet h-100">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <span class="m-portlet__head-text">SPREJETI</span>
                        </div>
                    </div>
                </div>
                <div
                    [cdkDropListData]="columns?.col2"
                    [id]="'col2'"
                    [cdkDropListConnectedTo]="['col1', 'col3', 'col4']"
                    (cdkDropListDropped)="drop($event)"
                    cdkDropList
                    class="m-portlet__body h-100"
                    [ngClass]="{ 'mf-highlight-column': highlightColumns.col2 }"
                >
                    <div
                        *ngFor="let comp of columns?.col2"
                        [cdkDragData]="comp"
                        (cdkDragStarted)="onDrag($event?.source)"
                        (cdkDragEnded)="endDrag($event)"
                        cdkDrag
                        class="element-container"
                    >
                        <inx-kab-item [data]="comp"></inx-kab-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl col-md-12 flex-grow-0">
            <div class="m-portlet h-100">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <span class="m-portlet__head-text">V OBRAVNAVI</span>
                        </div>
                    </div>
                </div>
                <div
                    [id]="'col3'"
                    [cdkDropListData]="columns?.col3"
                    [cdkDropListConnectedTo]="['col4']"
                    (cdkDropListDropped)="drop($event)"
                    cdkDropList
                    class="m-portlet__body h-100"
                    [ngClass]="{ 'mf-highlight-column': highlightColumns.col3 }"
                >
                    <div
                        *ngFor="let comp of columns?.col3"
                        [cdkDragData]="comp"
                        (cdkDragStarted)="onDrag($event?.source)"
                        (cdkDragEnded)="endDrag($event)"
                        cdkDrag
                        class="element-container"
                    >
                        <inx-kab-item [data]="comp"></inx-kab-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl col-md-12 flex-grow-0">
            <div class="m-portlet h-100">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <span class="m-portlet__head-text">ZAKLJUČENI</span>
                        </div>
                    </div>
                </div>
                <div
                    [id]="'col4'"
                    [cdkDropListData]="columns?.col4"
                    (cdkDropListDropped)="drop($event)"
                    (cdkDragStarted)="onDrag($event?.source)"
                    (cdkDragEnded)="endDrag()"
                    cdkDropList
                    class="m-portlet__body h-100"
                    [ngClass]="{ 'mf-highlight-column': highlightColumns.col4 }"
                >
                    <div *ngFor="let comp of columns?.col4" [cdkDragData]="comp" cdkDrag class="element-container">
                        <inx-kab-item [data]="comp"></inx-kab-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
